import { createFileRoute, redirect } from "@tanstack/react-router"
import { OrganizationBillingPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"
import { BILLING_TAB_KEYS } from "@/pages/OrganizationBillingPage/OrganizationBillingPage.utils"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/billing/$tabKey"
)({
  beforeLoad: ({ params }) => {
    if (
      !BILLING_TAB_KEYS.includes(params.tabKey as (typeof BILLING_TAB_KEYS)[number])
    ) {
      throw redirect({
        to: "/organization-settings/billing/$tabKey",
        params: { tabKey: "details" },
      })
    }
  },
  component: () => (
    <AuthorizationGate resource={Resource.PAYMENT} action={Action.MANAGE}>
      <OrganizationBillingPage />
    </AuthorizationGate>
  ),
})
